class TabsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.navButtons = this.querySelectorAll('.tabs-button[data-wrapper-id]');
    this.wrappers = this.querySelectorAll('.tabs-wrapper');

    if (this.navButtons.length === 0 || this.wrappers.length === 0) return;

    this.navButtons.forEach((button) => {
      button.addEventListener('click', this.handleOnNavButtonClick.bind(this));
    });
  }

  handleOnNavButtonClick(event) {
    event.preventDefault();

    const targetWrapper = Array.from(this.wrappers).find(
      (wrapper) => wrapper.id === event.target.dataset.wrapperId
    );

    if (!targetWrapper) return;

    this.wrappers.forEach((wrapper) =>
      wrapper.classList.toggle('hidden', wrapper !== targetWrapper)
    );

    this.navButtons.forEach((button) =>
      button.classList.toggle('is-active', button === event.target)
    );
  }
}

customElements.define('tabs-component', TabsComponent);
